import axios from "axios";
const axiosApiInstance = axios.create();
import utils from "../utils/utils";
// ...existing code...

let activeRequests = 0;
const showLoader = () => {
  activeRequests += 1;
  if (activeRequests === 1) {
    // emit a global event that UI can listen to
    window.dispatchEvent(new CustomEvent("loader", { detail: { show: true } }));
  }
};
const hideLoader = () => {
  if (activeRequests <= 0) return;
  activeRequests -= 1;
  if (activeRequests === 0) {
    window.dispatchEvent(
      new CustomEvent("loader", { detail: { show: false } })
    );
  }
};

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  (config) => {
    showLoader();
    config.headers = Object.assign(
      {
        authtoken: localStorage.getItem("auth_token"),
        schoolcode: localStorage.getItem("school_code"),
        userid: utils.getUserId(),
        user_type: utils.getUserType(),
      },
      config.headers
    );
    return config;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  }
);

// add response interceptor to hide loader
axiosApiInstance.interceptors.response.use(
  (response) => {
    hideLoader();
    return response;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  }
);

export default axiosApiInstance;
